module.exports = __webpack_public_path__ + "assets/img/ptp07.efdfeffa.png";